export const GC_BLANK_DEFAULT = 'GC_BLANK_DEFAULT';